import React from 'react'
import { ActivityIndicator } from 'react-native'

import { Icon } from '@zet/design-system/icons'
import { Stack, XStack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { B2, SH3 } from '@zet/design-system/typography'

type Props = {
  pincodes?: string[]
  onSelect: (pincode: string) => void
  title: string
  loading?: boolean
  isSuggestions?: boolean
}
export const PinCodeTags = ({
  pincodes,
  onSelect,
  title,
  loading = false,
  isSuggestions = false,
}: Props) => {
  return (
    <Stack className="mt-2">
      <SH3 className="text-grays-50 mt-2">{title}</SH3>
      {loading ? (
        <ActivityIndicator style={{ alignSelf: 'center' }} />
      ) : (
        <XStack className="flex-wrap">
          {pincodes?.map((pin, index) => (
            <Pressable
              opacity={1}
              key={`${index}+${pin}`}
              onPress={() => {
                onSelect(pin)
              }}
              eventName="click_action"
              eventPayload={{
                item_name: isSuggestions
                  ? 'suggested_pincode'
                  : 'recent_pincode',
              }}
            >
              <XStack
                className={`bg-grays-20 mx-1 mt-2 items-center justify-center space-x-1 rounded py-1 px-${
                  isSuggestions ? '3' : '2'
                }`}
              >
                {!isSuggestions && (
                  <Icon type="Timeline" size={16} color="#596379" />
                )}
                <B2 style={{ fontSize: 14 }}>{pin}</B2>
              </XStack>
            </Pressable>
          ))}
        </XStack>
      )}
    </Stack>
  )
}
